module.exports = __webpack_public_path__ + "img/mov.8583987e.jpg";